import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class WebhookTypes {
  static listUrls: IActionType = new ActionType('WEBHOOK/LIST_URLS');
  static changeUrlStatus: IActionType = new ActionType('WEBHOOK/CHANGE_URL_STATUS');
  static deleteUrl: IActionType = new ActionType('WEBHOOK/DELETE_URL');
  static listHistory: IActionType = new ActionType('WEBHOOK/LIST_HISTORY');
  static listSends: IActionType = new ActionType('WEBHOOK/LIST_SENDS');
  static listProducts: IActionType = new ActionType('WEBHOOK/LIST_PRODUCTS');
  static createUrl: IActionType = new ActionType('WEBHOOK/CREATE_URL');
  static updateUrl: IActionType = new ActionType('WEBHOOK/UPDATE_URL');
  static sendTest: IActionType = new ActionType('WEBHOOK/SEND_TEST');
  static resendWebhook: IActionType = new ActionType('WEBHOOK/RESEND');
}

export default WebhookTypes;
